export interface NotificationReminderTimeModel {
  id?: string
  createdAt?: Date
  hours?: number
}

export class NotificationReminderTime implements NotificationReminderTimeModel {
  constructor(
    public id?: string,
    public createdAt?: Date,
    public hours?: number
  ) { }

  static convertFromParseObject(parseObject: Parse.Object): NotificationReminderTime {
    return new NotificationReminderTime(
      parseObject.id,
      parseObject.createdAt,
      parseObject.get("hours")
    )
  }
}
